import type { ButtonHTMLAttributes } from 'react';
import { cn } from '../../shared/cn';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';

const variants: Record<Variant, string> = {
  primary: 'bg-[#75816a] text-white hover:bg-[#65735c]',
  secondary: 'border border-[#d6ded0] bg-white text-[#334033] hover:bg-[#eef3ea]',
  ghost: 'text-[#4f5d49] hover:bg-[#eef3ea]',
  danger: 'bg-[#cf7766] text-white hover:bg-[#bd6656]',
};

export function Button({ className, variant = 'primary', ...props }: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant }) {
  return (
    <button
      className={cn(
        'inline-flex h-9 items-center justify-center gap-2 rounded-md px-3 text-sm font-medium transition-[background-color,border-color,color,box-shadow,transform] duration-150 active:scale-[0.98] disabled:pointer-events-none disabled:opacity-50',
        variants[variant],
        className,
      )}
      {...props}
    />
  );
}
